import {LogType} from '../../../../webmate/shared/console/types/shared';

export interface LogMessage {
    type?: LogType;
    timestamp?: string;
    tag?: string;
    process?: string;
    message: string;
}

export interface LogFilter {
    types?: LogType[];
    message?: string;
    tag?: string;
    process?: string;
    fromTime?: Date;
    toTime?: Date;
}

export function checkFilter(msg: LogMessage, filter: LogFilter): boolean {
    if (filter) {
        if (filter.types && filter.types.length > 0 && msg.type) {
            if (filter.types.indexOf(msg.type) === -1) {
                return false;
            }
        }
        if (filter.message) {
            const lm = filter.message.toLowerCase();
            if (`${msg.message?.toLowerCase()}${msg.tag?.toLowerCase()}${msg.timestamp?.toLowerCase()}`.indexOf(lm) === -1) {
                return false;
            }
        }
        if (filter.tag) {
            if (!msg.tag || msg.tag.toLowerCase().indexOf(filter.tag.toLowerCase()) === -1) {
                return false;
            }
        }
        if (filter.process) {
            if (!msg.process || msg.process.toLowerCase().indexOf(filter.process.toLowerCase()) === -1) {
                return false;
            }
        }
        if (filter.fromTime || filter.toTime) {
            let msgTime = new Date();
            let time = msg.timestamp?.split(':') as [string, string, string];
            msgTime.setHours(+time[0], +time[1], +time[2], 0);
            if (filter.fromTime) {
                // Make sure the millis don't affect the matching
                filter.fromTime.setMilliseconds(0);
                if (msgTime < filter.fromTime) {
                    return false;
                }
            }
            if (filter.toTime && msgTime > filter.toTime) {
                return false;
            }
        }
    }

    return true;
}

export function applyFilter(values: LogMessage[], filter: LogFilter): LogMessage[] {
    if (filter) {
        return values.filter(msg => checkFilter(msg, filter));
    } else {
        return [...values];
    }
}
